export default "__VITE_ASSET__BUISgh2v__"